"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CheckboxChecked = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _colors = _interopRequireDefault(require("../../colors"));

var _styled = require("./styled");

var CheckboxChecked = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(CheckboxChecked, _PureComponent);

  var _super = (0, _createSuper2["default"])(CheckboxChecked);

  function CheckboxChecked() {
    (0, _classCallCheck2["default"])(this, CheckboxChecked);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CheckboxChecked, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          height = _this$props.height,
          width = _this$props.width,
          rounded = _this$props.rounded,
          checked = _this$props.checked,
          indeterminate = _this$props.indeterminate,
          disabled = _this$props.disabled;
      return /*#__PURE__*/_react["default"].createElement(_styled.SvgIcon, {
        height: height,
        width: width,
        rounded: rounded,
        disabled: disabled,
        checked: checked,
        indeterminate: indeterminate,
        viewBox: "0 0 ".concat(width, " ").concat(height)
      }, indeterminate && /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        fill: _colors["default"].lychee[100],
        points: "15 11 5 11 5 9 15 9"
      })), checked && !indeterminate && /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "check-box-checked-a",
        fill: _colors["default"].lychee[100],
        fillRule: "nonzero",
        points: "13.915 7 8.846 11.897 6.085 9.237 5 10.285 8.846 14 15 8.055"
      })), /*#__PURE__*/_react["default"].createElement("use", {
        xlinkHref: "#check-box-checked-a"
      })));
    }
  }]);
  return CheckboxChecked;
}(_react.PureComponent);

exports.CheckboxChecked = CheckboxChecked;
CheckboxChecked.defaultProps = {
  height: 20,
  width: 20,
  rounded: false,
  checked: false,
  indeterminate: false,
  disabled: false
};
var _default = CheckboxChecked;
exports["default"] = _default;